import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    token: "",
    user: null,
    uaa: null,
    isAuthenticated: false,
    masterData: {},
    customFields: [],
    lawfirms: [],
    tasks: [],
    rateCards: [],
    roleTasksMasterMappings: [],
  },
  mutations: {
    login(state, token) {
      state.token = token;
      state.isAuthenticated = true;
    },
    populateMR(state, masterData) {
      state.masterData = masterData;
    },
    init(state) {
      state.createAgainMode = false;
    },
    user(state, account) {
      state.user = account.user;
    },
    uaa(state, uaa) {
      state.uaa = uaa;
    },
    customFields(state, fields) {
      state.customFields = fields;
    },
    lawfirms(state, lawfirms) {
      state.lawfirms = lawfirms;
    },
    tasks(state, tasks) {
      state.tasks = [...new Set(tasks)];
    },
    rateCards(state, rateCards) {
      state.rateCards = rateCards;
    },
    updateRateCard(state, rateCard) {
      const index = state.rateCards.findIndex((r) => r.id == rateCard.id);
      state.rateCards.splice(index, 1, rateCard);
    },
    updateRoleTasksMasterMappings(state, items) {
      state.roleTasksMasterMappings = items;
    },
    updateRateCardTaskMappings(state, { id, mappings }) {
      const index = state.rateCards.findIndex((r) => r.id === id);
      state.rateCards[index].taskMappings = mappings;
    },
    updateRateCardCarrierLawFirmMappings(state, { id, mappings }) {
      const index = state.rateCards.findIndex((r) => r.id === id);
      state.rateCards[index].mappings = mappings;
    },
  },
  getters: {
    createAgainMode: (state) => state.createAgainMode,
    state: (state) => state,
    token: (state) => state.token,
    user: (state) => state.user,
    uaa: (state) => state.uaa,
    isAuthenticated: (state) => state.isAuthenticated,
    masterData: (state) => state.masterData,
    hasMasterData: (state) => state.masterData,
    customFields: (state) => state.customFields,
    tasks: (state) => state.tasks,
    customFieldById: (state) => (id) => state.customFields.find((cf) => cf.id === id),
    rateCards: (state) => state.rateCards,
    rateCardById: (state) => (id) => state.rateCards.find((r) => r.id === id),
    roleTasksMasterMappings: (state) => state.roleTasksMasterMappings,
  },
  actions: {},
});
